export default {"src":"/_next/static/media/cultura.e598e60e.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};